import {
  DxDataGrid,
  DxScrolling,
  DxColumn,
  DxPaging,
  DxPager,
  DxFilterRow,
  DxColumnChooser,
  DxRequiredRule,
  DxPosition,
  DxSelection,
  DxLoadPanel,
  DxToolbar,
  DxItem,
  DxEditing,
  DxCustomRule,
} from "devextreme-vue/data-grid";
import store from "@/store";
import "devextreme/dist/css/dx.light.css";

import DeleteDialog from "@/@core/components/delete-dialog/DeleteDialog.vue";

import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { Fragment } from "vue-fragment";
import { useFetch } from "../Hooks/useFetch.ts";

import { ref, defineComponent, PropType } from "@vue/composition-api";
import { useElementSize } from "@vueuse/core";

export default defineComponent({
  name: "EzTable",
  props: {
    forceDisplayActions:Boolean,
    excelExportApiCode: String,
    excelExportParams: Object,
    excelExport: Function,
    customComponent: Object,
    show: Boolean,
    actionsConfig: {
      type: Object,
      default() {
        return {};
      },
    },
    externalLoading: {
      type: Boolean,
      default: false,
    },
    toolbarConfig: {
      type: Object,
      default() {
        return {};
      },
    },
    toolbarActions: {
      type: Array,
      default: () => {
        return [];
      },
    },

    selectionConfig: {
      type: Object,
      nullable: true,
    },
    actionType: String,
    actions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    pageConfig: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dataSourceParams: {
      type: Object,
      nullable: true,
    },
    // if dataSource is function , must be promise with final Data return
    dataSource: [Array, Function],

    columnResizingMode: String,
    columns: Array,
    editingConfig: Object,
    editable: Boolean,
  },
  components: {
    DxPosition,
    DxCustomRule,
    DxToolbar,
    Fragment,
    DxLoadPanel,
    DxItem,
    DxColumn,
    DeleteDialog,
    DxSelection,
    DxEditing,
    DxRequiredRule,
    DxDataGrid,
    DxColumnChooser,
    DxScrolling,
    DxPaging,
    DxPager,
    DxFilterRow,
  },
  setup(props) {
    const rawDataSourceParams = ref({ ...props.dataSourceParams, OffSet: 0, Limit: 10 });

    const { isLoading, data, totalCount } = useFetch(props.dataSource, {
      params: rawDataSourceParams,
    });
    const dataResponse = ref({});

    return { isLoading, data, totalCount, rawDataSourceParams, dataResponse };
  },
  data() {
    return {
      rawDataSource: [],
    };
  },
  methods: {
    calculateWidth(type) {
      let width = undefined;
      if (type === "currency") {
        width = 100;
      }
      return width;
    },
    onContentReady(e) {},
    truncateWidth(v) {
      if (v) {
        return `width: ${v};`;
      }
      return "";
    },
    async handleExportExcel() {
      await this.excelExport(this.excelExportParams).then((res) => {
        const decodedData = Buffer.from(res.Data.FileContents, "base64");
        const newBlob = new Blob([decodedData], {
          type: res.Data.ContentType,
        });
        const url = window.URL.createObjectURL(newBlob);
        const a = document.createElement("a");
        a.href = url;
        a.download =
          res.Data.FileDownloadName + "_" + this.dayjs(new Date()).format("DD/MM/YYYY HH:mm:ss");
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },
    fetchData() {
      if (this.functionDataSource) {
        const tempDataSourceParams = this.dataSourceParams;
        const rawApi = this.dataSource;
        const self = this;
        let tempDataResponse = {};

        this.rawDataSource = new DataSource({
          store: new CustomStore({
            loadMode: "processed",

            load(loadOptions) {
              let options = {
                ...tempDataSourceParams,
                Limit: loadOptions.take,
                OffSet: loadOptions.skip || 0,
              };
              if (loadOptions.customQueryParams)
                options = { ...options, ...loadOptions.customQueryParams };
              return rawApi(options)
                .then((response) => {
                  loadOptions.requireTotalCount = true;
                  let tempData = [];
                  const dataValues = Object.values(response.Data);
                  console.log(this, "1644");
                  self.dataResponse = response.Data;
                  dataValues.forEach((item) => {
                    if (Array.isArray(item)) {
                      tempData = item;
                    }
                  });
                  return {
                    data: tempData,
                    totalCount: response.Data.TotalCount,
                  };
                })
                .catch(() => {
                  throw "Network error";
                });
            },
          }),
        });
      } else {
        this.rawDataSource = this.dataSource;
      }
    },
    renderDate(value, dateConfig) {
      let format = "DD/MM/YYYY HH:mm";

      /* if (dateConfig?.showTime) {
        format += " hh:mm";
      } */
      return this.formatDate(value);
    },
    onEditorPreparing: function (e) {
      if (
        e.parentType == "headerRow" &&
        e.command == "select" &&
        (this.selectionConfig?.mode === "Single" || this.selectionConfig?.hideSelectAll)
      ) {
        e.editorElement.remove();
      }
      this.$emit("onEditorPreparing", e);
    },
    renderSlotHeader(fieldName) {
      return fieldName + "-header";
    },
    handlePropertyChange: function (e) {
      if (this.functionDataSource) {
        if (e.fullName.includes("sortOrder")) {
        }
      }
    },
    renderColAlign(type) {
      let align = "left";
      if (type === "num" || type === "currency") {
        align = "right";
      }
      if (type === "date" || type === "text-variant") {
        align = "center";
      }
      return align;
    },

    onCellClick(e) {
      if (e.column.type === "selection") {
        return;
      }
      this.$emit("cellClick", e);
    },
  },
  watch: {
    dataSource: {
      handler: function (value) {
        if (!this.functionDataSource) {
          this.rawDataSource = value;
        }
      },
      deep: true,
    },
    dataSourceParams: {
      handler: function (value) {
        if (value) {
          this.rawDataSourceParams = { ...this.dataSourceParams };
        }
      },
      deep: true,
    },
  },
  created() {
    this.fetchData();
  },

  computed: {
    dataGridInstance(){
      return this.$refs.dxDatagridRef.instance
    },
    permissionList() {
      return this.permissionsParsed
        ? this.permissionsParsed.map((func) => func.PermissionCode)
        : [];
    },
    functionDataSource() {
      return typeof this.dataSource === "function";
    },

    actionsSplit() {
      let value = { iconActions: [], dropDownActions: [] };
      if (this.actions.length > 0) {
        const temp = this.actions;
        if (temp.length > 0) {
          const iconActions = temp.length <= 3 ? temp.slice(0, 3) : temp.slice(0, 2);
          const dropDownActions = temp.length > 3 ? temp.slice(2, temp.length) : [];

          value = { iconActions, dropDownActions };
        }
      }
      return value;
    },

    templateArr() {
      return this.columns?.filter((c) => c.cellTemplate) || [];
    },
    hasSelectionChangeListener() {
      return this.$listeners && this.$listeners["selection-changed"];
    },
    hasExportListener() {
      return this.$listeners && (this.$listeners["export-excel"] || this.$listeners["export-pdf"]);
    },
  },
});
